<div class="mapa-wrapper">

  <!-- Sidebar: selector de ciudad + lista de conductores -->
  <div class="mapa-sidebar">

    <div class="sidebar-section border-bottom">
      <label for="ciudad-select" class="fw-semibold mb-2 d-block">Ciudad</label>
      <p-dropdown
        inputId="ciudad-select"
        [options]="citiesList"
        [(ngModel)]="selectedCity"
        optionLabel="pd_name"
        placeholder="Selecciona ciudad"
        [style]="{ width: '100%' }"
        appendTo="body"
        (onChange)="onCityChange($event.value)"
      />
    </div>

    @if (connectionStatus !== 'connected') {
      <div class="connection-banner" [class.connection-banner--reconnecting]="connectionStatus === 'reconnecting'">
        <i class="pi"
           [class.pi-spin]="connectionStatus === 'reconnecting'"
           [class.pi-spinner]="connectionStatus === 'reconnecting'"
           [class.pi-exclamation-triangle]="connectionStatus === 'disconnected'"></i>
        <span>{{ connectionStatus === 'reconnecting' ? 'Reconectando...' : 'Sin conexión' }}</span>
        @if (connectionStatus === 'disconnected') {
          <button class="btn-retry" [disabled]="isRetrying" (click)="retryConnection()">
            <i class="pi"
               [class.pi-refresh]="!isRetrying"
               [class.pi-spin]="isRetrying"
               [class.pi-spinner]="isRetrying"></i>
            {{ isRetrying ? 'Conectando...' : 'Reintentar' }}
          </button>
        }
      </div>
    }

    <div class="sidebar-section border-bottom d-flex align-items-center gap-2">
      <span class="fw-semibold">Conductores activos:</span>
      <p-badge [value]="driversList.length.toString()" severity="success" />
    </div>

    <div class="sidebar-list">
      @for (driver of driversList; track driver.driverId) {
        <button
          class="driver-item"
          [class.driver-item--selected]="selectedDriver?.driverId === driver.driverId"
          (click)="centerOnDriver(driver)">
          <i class="pi pi-car text-warning me-2"></i>
          <div class="driver-info">
            <span class="driver-name">
              {{ driver.driverName || driver.driverId }}
              {{ driver.driverLastName }}
            </span>
            @if (driver.driverName) {
              <small class="driver-phone">{{ driver.driverId }}</small>
              <small class="driver-phone">{{ driver.driverPlate }}</small>
              <small class="driver-phone">{{ driver.driverCompany }}</small>
            }
          </div>
        </button>
      }
      @if (driversList.length === 0) {
        <div class="p-3 text-center text-muted">
          <small>Sin conductores activos</small>
        </div>
      }
    </div>

  </div>

  <!-- Mapa principal: marcadores manejados imperativamente via AdvancedMarkerElement -->
  <div class="mapa-main">
    <google-map
      height="100%"
      width="100%"
      [options]="options"
      [center]="center"
      [zoom]="zoom">
    </google-map>
  </div>

</div>
